// Component Name:  RouteWithAPIFetch component
// Author: Lavanya S
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original implementation
// Date: 23-04-2025
// Description: Higher order function that loads after the user is authenticated and wraps araound the component
//  currently used to load the charger and location Ids based on the path
// Dependencies: React,  Redux (for addToastMessage,removeToastMessage)
// Interfaces: Accepts props including redux data and Component
// Maintenance History:  1.0 - First Version
import React, { Component } from "react";
import "nouislider/distribute/nouislider.css";
import {
  addChargerIds,
  chargerSelected,
  loginUserSuccessful,
  logoutUser,
  resetChargerData,
} from "../store/actions";
import { addLocationIds, resetLocationData } from "../store/locations/actions";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { getInitialData, validateToken } from "../api/authAPI";
import { addChargerToLocationMap } from "../store/dbFilter/actions";
import { mapChargersToLocation } from "../api/utils/locationToChargerMap";
import { publicRoutes } from ".";
import { addHostIds } from "../store/hostTech/actions";
import { isTechnician } from "../pages/Authentication/userMetaData";

class RouteWithAPIFetch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chargerId: [],
      locationId: [],
      hostId: [],
      prevChargerStatus: {},
      syncIntervalId: "",
    };
    this.chargerId = "all";
    // cms-chargers: to show all the available chargers
    // dashboard: charger data is required in utilization rate to calc the totalpower
    // cms-multi-locations: to show the number of chargers in a location
    this.requiresChargerData = [
      "/cms-chargers",
      "/dashboard",
      "/cms-multi-locations",
      "/cms-report",
    ];

    // cms-multi-locations: to show all the locations available
    // dashboard: to show list of locations in the filter
    // cms-add-chargers: to provide the list of locations, while adding the charger
    this.requiresLocationData = [
      "/cms-multi-locations",
      "/dashboard",
      "/cms-add-chargers",
      "/cms-charger-detail",
      "/cms-report",
    ];

    this.requiresChargerToLocationMap = ["/dashboard", "/cms-report"];

    // routes allowed for tech
    this.techPrivateRoutes = [
      "/cms-chargers",
      "/cms-charger-detail",
      "/cms-tech-projects",
      "/cms-multi-locations",
      ,
    ];

    this._isMounted = false;
  }

  componentDidMount() {
    // on component mount check the role
    // if tech role, then technician will be restrictedd to access the pages outside this
    const isTech = isTechnician(this?.props?.user);
    const { pathname } = this.props.location;
    if (isTech) {
      if (!this.techPrivateRoutes?.includes(pathname)) {
        this.props.history.push("/cms-chargers");
      }
    }
    const isAuth = publicRoutes?.findIndex(
      (item) => item?.path === this.props.location.pathname
    );
    // console.log("isAuth: ", isAuth);

    // isAuth -1 indicates that the path is not in the public route
    if (isAuth === -1) {
      this._isMounted = true;
      // window.addEventListener('beforeunload', this.handleTabClose,{capture:true});
      // const userData = , token,user.isRemember);
      // Mark component as mounted

      const { chargerIds, locationIds, location } = this.props;
      // check whether token is stored in the cookies, if present store it in the session
      const tokenValue = Cookies.get("token");
      if (tokenValue?.length > 0) {
        sessionStorage.setItem("token", tokenValue);
      }

      // if token exists validate it or logout
      if (
        sessionStorage.getItem("token") &&
        sessionStorage.getItem("token")?.length > 0 &&
        Object.keys(this.props.user)?.length > 0
      ) {
        // if (tokenValue?.length > 0) {
        const token = tokenValue || this.props.user?.token;
        this.handleTokenValidation(token);
        // }
      } else {
        this.props.logoutUser(this.props.history);
      }

      // once the token is validated then perform initial fetch
      if (
        Object.keys(this.props.user)?.length > 0 &&
        sessionStorage.getItem("token")
      ) {
        this.handleFetchInitialData();
      }
    }
  }

  // ****************************************FETCH CHARGER/HOST/LOCATION ***************************************************

  // fetch all the chargerIds,hostIds and LocationIds that belongs to the current host
  handleFetchInitialData = async () => {
    const { email, token, parentId, role } = this?.props?.user;
    const { location } = this.props;
    try {
      // If it is technician fetch data based on the parentId else emailId
      const emailId = isTechnician(this?.props?.user) ? parentId : email;
      const data = await getInitialData(emailId, token);

      const { chargerIds, hostIds, locationIds } = data;
      if (this._isMounted) {
        this.setState({
          chargerId: chargerIds,
          locationId: locationIds,
          hostId: hostIds,
        });
      }

      if (
        chargerIds?.length > 0 &&
        this.requiresChargerData?.includes(location?.pathname)
      ) {
        this.props.addChargerIds(chargerIds);
      }
      if (
        locationIds?.length > 0 &&
        this.requiresLocationData?.includes(location?.pathname)
      ) {
        if (
          location?.pathname !== "/cms-charger-detail" &&
          !isTechnician(this?.props?.user)
        ) {
          this.props.addLocationIds(locationIds);
        }
      }
      if (hostIds?.length > 0 && !isTechnician(this?.props?.user)) {
        this.props.addHostIds(hostIds);
      }
      if (
        chargerIds?.length > 0 &&
        locationIds?.length > 0 &&
        this.requiresChargerToLocationMap?.includes(location?.pathname)
      ) {
        const mapData = await mapChargersToLocation(chargerIds);
        this.props.addChargerToLocationMap(mapData);
      }
    } catch (err) {
      console.log("Error Logging in: ", err.msg || err);
    }
  };

  // ********************************************VALIDATE TOKEN *********************************************************
  /**
   * validates token, if success userData along with token will be stored in the redux else through error
   * @param {string} tokenValue : token string
   *
   */
  handleTokenValidation = async (tokenValue) => {
    try {
      const userData = await validateToken(tokenValue);
      loginUserSuccessful({ ...userData, token: tokenValue });
    } catch (err) {
      console.log("Error Logging in: ", err.msg || err);
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }
  // render the component
  render() {
    if (this.props.Component) {
      const { Component, ...restProps } = this.props;
      return (
        <>
          <Component {...restProps} />
        </>
      );
    }
    return <div>Loading...</div>;
  }
}

const mapStateToProps = (state) => ({
  user: state?.Login?.user,
  chargerIds: state?.ChargerManagement?.chargerIds,
  locationIds: state?.LocationManagement?.locationIds,
});

const mapDispatchToProps = (dispatch) => ({
  loginUserSuccessful: (payload) => dispatch(loginUserSuccessful(payload)),
  chargerSelected: (payload) => dispatch(chargerSelected(payload)),
  logoutUser: (payload) => dispatch(logoutUser(payload)),
  resetChargerData: () => dispatch(resetChargerData()),
  resetLocationData: () => dispatch(resetLocationData()),
  addChargerIds: (payload) => dispatch(addChargerIds(payload)),
  addLocationIds: (payload) => dispatch(addLocationIds(payload)),
  addHostIds: (payload) => dispatch(addHostIds(payload)),
  addChargerToLocationMap: (payload) =>
    dispatch(addChargerToLocationMap(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteWithAPIFetch);
